import c0 from './accordion_component_controller';
import c1 from './alert_bar_controller';
import c2 from './audio_player_component_controller';
import c3 from './block/carousel_component_controller';
import c4 from './block/confirm_dialog_component_controller';
import c5 from './block/feedback/prompt_controller';
import c6 from './block/forms/color_picker_component_controller';
import c7 from './block/global_confirm_component_controller';
import c8 from './block/live_chat/replay_controller';
import c9 from './block/newsletter/clip_component_controller';
import c10 from './block/newsletter/video_component_controller';
import c11 from './block/onboarding/checklist_panel_component_controller';
import c12 from './block/sidebar_announcements_component_controller';
import c13 from './block/upload_status_widget_component_controller';
import c14 from './bridge/ready_controller';
import c15 from './button_component_controller';
import c16 from './drawer_controller';
import c17 from './dropdown_controller';
import c18 from './element/celebration_button_component_controller';
import c19 from './feature_callout_component_controller';
import c20 from './filters/date_range_component_controller';
import c21 from './filters/email_tokenizer_component_controller';
import c22 from './forms/timestamp_component_controller';
import c23 from './media/audio_player_controller';
import c24 from './media/bridge/live_player_controller';
import c25 from './media/bridge/playback_controls_controller';
import c26 from './media/bridge/premiere_player_controller';
import c27 from './media/bridge/video_player_controller';
import c28 from './media/playback_controls_controller';
import c29 from './media/video_player_controller';
import c30 from './modal_component_controller';
import c31 from './offer_component_controller';
import c32 from './patreon_offer_component_controller';
import c33 from './price_component_controller';
import c34 from './qr_code_controller';
import c35 from './rolling_number_controller';
import c36 from './stats_component_controller';
import c37 from './targeting_component_controller';
import c38 from './tus_upload_component_controller';
import c39 from './typeahead_component_controller';
import c40 from './ui/table_component_controller';
import c41 from './ui/table_component_filter_controller';
export const definitions = [
	{identifier: 'accordion-component', controllerConstructor: c0},
	{identifier: 'alert-bar', controllerConstructor: c1},
	{identifier: 'audio-player-component', controllerConstructor: c2},
	{identifier: 'block--carousel-component', controllerConstructor: c3},
	{identifier: 'block--confirm-dialog-component', controllerConstructor: c4},
	{identifier: 'block--feedback--prompt', controllerConstructor: c5},
	{identifier: 'block--forms--color-picker-component', controllerConstructor: c6},
	{identifier: 'block--global-confirm-component', controllerConstructor: c7},
	{identifier: 'block--live-chat--replay', controllerConstructor: c8},
	{identifier: 'block--newsletter--clip-component', controllerConstructor: c9},
	{identifier: 'block--newsletter--video-component', controllerConstructor: c10},
	{identifier: 'block--onboarding--checklist-panel-component', controllerConstructor: c11},
	{identifier: 'block--sidebar-announcements-component', controllerConstructor: c12},
	{identifier: 'block--upload-status-widget-component', controllerConstructor: c13},
	{identifier: 'bridge--ready', controllerConstructor: c14},
	{identifier: 'button-component', controllerConstructor: c15},
	{identifier: 'drawer', controllerConstructor: c16},
	{identifier: 'dropdown', controllerConstructor: c17},
	{identifier: 'element--celebration-button-component', controllerConstructor: c18},
	{identifier: 'feature-callout-component', controllerConstructor: c19},
	{identifier: 'filters--date-range-component', controllerConstructor: c20},
	{identifier: 'filters--email-tokenizer-component', controllerConstructor: c21},
	{identifier: 'forms--timestamp-component', controllerConstructor: c22},
	{identifier: 'media--audio-player', controllerConstructor: c23},
	{identifier: 'media--bridge--live-player', controllerConstructor: c24},
	{identifier: 'media--bridge--playback-controls', controllerConstructor: c25},
	{identifier: 'media--bridge--premiere-player', controllerConstructor: c26},
	{identifier: 'media--bridge--video-player', controllerConstructor: c27},
	{identifier: 'media--playback-controls', controllerConstructor: c28},
	{identifier: 'media--video-player', controllerConstructor: c29},
	{identifier: 'modal-component', controllerConstructor: c30},
	{identifier: 'offer-component', controllerConstructor: c31},
	{identifier: 'patreon-offer-component', controllerConstructor: c32},
	{identifier: 'price-component', controllerConstructor: c33},
	{identifier: 'qr-code', controllerConstructor: c34},
	{identifier: 'rolling-number', controllerConstructor: c35},
	{identifier: 'stats-component', controllerConstructor: c36},
	{identifier: 'targeting-component', controllerConstructor: c37},
	{identifier: 'tus-upload-component', controllerConstructor: c38},
	{identifier: 'typeahead-component', controllerConstructor: c39},
	{identifier: 'ui--table-component', controllerConstructor: c40},
	{identifier: 'ui--table-component-filter', controllerConstructor: c41},
];
